export enum Validation {

  ScoreSize = 10,                    // 0-100
  DialogTextSize = 30,
  //TODO: Check if these has to be moved to a different enum?
  DialogWidth = 500,
  DialogWidthForFileExplorer = 750,    //Use for dialog's which use file explorer component, Added as part of sso-7483
  BaseZIndexForFileExplorerDialog = 100,  //Using a low z-index for the dialog which use file explorer components. As the confirm dialog has a high z-index
  DialogTextareaRows = 2,
  DialogTextareaCols = 30,

  ScoreLength = 3,                  // 0-100
  MediumTextMaxLength = 65535,
  DescriptionMaxLength = 255,
  DescriptionRows = 5,
  DescriptionColumns = 40,
  LargeDescriptionMaxLength = 1024,
  YearMaxLength = 4,
  NameMaxLength = 50,
  TypeMaxLength = 20,
  MaxIntegerValue = 2147483647,
  DefaultCreditLimitForGovAgency = 10000000,

  AutoCompleteMinLength = 3,
  AutoCompletePlaceholder = "Type 3 chars",
  AutoCompleteEmptyMessage = "No result found",

  CalendarPlaceholder = "Select...",
  DateMaxLength = 10,

  DropdownPlaceholder = "Select...",
  AddressPlaceholder = "Select Address..",

  NotApplicable = "-",

  GlobalFilterPlaceholder = "Global Filter",
  DefaultTableSize = 10,

  ExcelFileType = "application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",

  HelpWidth = 560,
  HelpHeight = 315,

// workflist
  WorklistStringSize = 20,

  // hcm user/employeex

  AddrMaxLength = 40,
  CityMaxLength = 40,
  StateCodeMaxLength = 40,
  PeriodNameMaxLength = 50,
  NameMaxTextLength = 255,
  UsZipMinLength = 5,
  UsZipMaxLength = 10,
  NonUsZipMinLength = 4,
  NonUsZipMaxLength = 12,
  TextMaxLength = 20,
  WorkEmailMaxLength = 255,
  ReasonDescMaxLength = 80,
  ScreeningQuestionLength = 4096,
  ScreeningQuestionChoiceLength = 60,
  TermNoteMaxLength = 1024,

  // hcm
  AppraisalNameMaxLength = 100,
  ScreeningQuestionCategoryName = 20,
  ExpenseDescription = 255,
  ReviewPeriodMaxLength = 3,
  JobSiteContactEmailMaxLength = 60,
  PositionDescriptionMaxLength = 512,
  PositionGradeDescriptionMaxLength = 100,

  // hcm appraisal
  ApprRatingMaxLength = 20,
  ApprSummaryMaxLength = 2048,

  // hcm education
  GrantingInstitutionMaxLength = 40,

  // hcm garnishment
  GarnishmentTextMaxLength = 40,


  // hcm recruit to hire
  JobTitleMaxLength = 255,
  QualificationMaxLength = 2048,

  // HCM Positions
  AgeMaxLength = 3,

  //item catalog
  CatalogName = 30,
  CatalogDescription = 65,
  AisleRackShelfMaxLength = 20,
  FloorMaxLength = 11,
  NameOrNumberMaxLength = 30,
  UnitCostMaxLength = 14,
  ReorderMaxLength = 20,

  // finance
  AmountMaxLength = 14,
  AccountGroupLength = 50,
  CommentMaxLength = 512,
  VendorNameMaxLength = 40,
  RateChangeNameLength = 40,

  // org
  SignatureLength = 40,
  SignatureImageSize = 100000,
  SignatureImageType = "image/gif, image/png",

  // solution manager
  DocPrefixLength = 3,
  MaxRefCodeName = 50,

  // General fields
  nameMaxLength = 40,
  websiteURL = 50,

  // trading partner
  DaysMaxLength = 2,
  OfficePhoneExtMaxLength = 4,
  DiscountMaxLength = 5,
  CageCodeMaxLength = 5,
  TaxNumberMaxLength = 9,
  DunsNumberMaxLength = 9,
  CreditLimitMaxLength = 11,
  StateNameMaxLength = 15,
  AccountNumberMaxLength = 17,
  FirstLastNameMaxLength = 20,


  TermNameMaxLength = 20,
  ContactTitleMaxLength = 40,
  AdditionalInfoMaxLength = 60,
  EmailMaxLength = 60,

  //TODO
  ToDoTitle = 40,
  ToDoDescription = 255,

  //Contract
  SlaNameMaxLength = 40,
  SlaMetricTypeMaxLength = 20,
  SlaCalculationMaxLength = 255,
  ContractAwardValueStepFactor = 0.25,
  ContractAwardValueMinValue = 0,
  ContractTitleMaxLength = 40,
  ContractNumberMaxLength = 40,
  ContractEscalationFactorMaxLength = 6,

  // ContractFunding
  ContractClinFundingName = 20,
  ContractClinFundingDescription = 40,
  MinContractAccessFee = 0,
  MaxContractAccessFee = 100,
  MinQtyOrdered = 0.0,
  MinUnitPrice = 0,
  UnitPriceValueStepFactor = 0.01,
  DefaultLaborPeriodStepFactor = 1,
  minExperienceInYear = 0,
  maxExperienceInYear = 100,
  laborPeriodLength = 0,

  // labor category
  PositionTitleMaxLength = 60,
  LaborCategoryCodeMaxLength = 20,

  // milestone
  MilestoneNameMaxLength = 40,

  // Customer Sales Order
  SalesOrderMaxPONumber = 20,
  SalesOrderMaxPurpose = 512,

  // Customer Invoice
  noError = 0,


  MaxNumOfCharsExceeded = "Cannot exceed the maximum number of characters.",
  RequiredFieldMissing = "This is a required field.",

  //Dwolla Maximum allowed funding sources
  MaxNumOfAllowedAchAccounts = 6,
  //ACH Validations
  BankAccountNumberMinLength = 4,
  BankAccountNumberMaxLength = 17,
  BankRoutingNumberMaxLength = 9,
  BankNickNameMaxLength = 45,
  BankNameMaxLength = 20,
  BankAccountNameMaxLength = 20,


  //CostPool Setup Validation:

  CostPoolNameLength = 55,
  CostPoolDescriptionLength = 255,
  CostPoolDescriptionRow = 5,
  CostPoolDescriptionCol = 40,
  ProvisionalRateMaxLength = 7,
  EquationDialogWidth = 500,
  EquationDialogHeight = 200,
  ShowCostPoolAccountsDialogWidth = 500,
  ShowAddFiscalPoolYearSelectionDialogWidth = 400,
  ShowAppliedPoolAddEditDialogWidth = 400,
  ShowAllocationPoolAddEditDialogWidth = 400,


  //Cyberplan
  CyberplanDescriptionRow = 8,
  CyberplanDescriptionColumn = 120,
  CyberplanDescriptionMaxLength = 255,
  CyberplanSystemIdentifierLength = 40,
  CyberplanCageCodesLength = 18,
  CyberplanSystemEnvironmentLength = 255,
  CyberplanSystemMissionLength = 255,
  CyberplanSystemTextAreaRow = 5,
  CyberplanSystemTextAreaColumn = 40,
  CyberplanSolutionTaskLength = "128",

  CyberplanHardwareNameLength = 40,
  CyberplanHardwareHostNameLength = 20,
  CyberplanHardwareIpAddressLength = 20,
  CyberplanHardwareOsCategoryLength = 20,
  CyberplanHardwareOsNameLength = 40,
  CyberplanHardwareOsVersionLength = 20,
  CyberplanHardwarePatchLevelLength = 20,
  CyberplanHardwareVendorLength = 40,
  CyberplanHardwareModelLength = 20,
  CyberplanMacAddressLength = 20,
  CyberplanSerialNumberLength = 20,

  CyberplanHardwareDescriptionLength = 255,
  CyberplanHardwareDescriptionRow = 5,
  CyberplanHardwareDescriptionCol = 40,

  CyberplanSoftwareNameLength = 40,
  CyberplanSoftwareVendorLength = 40,
  CyberplanSoftwarePatchLevelLength = 20,
  CyberplanSoftwareVersionLength = 20,

  CyberplanUserFirstNameLength = 20,
  CyberplanUserLastNameLength = 20,
  CyberplanUserPhNoLength = 12,
  CyberplanUserEmailLength = 60,

  CyberplanThreatNameLength = 40,
  CyberplanThreatReferenceLength = 40,
  CyberplanThreatTextAreaRow = 5,
  CyberplanThreatTextAreaColumn = 20,

  CyberplanPolicyNameLength = 40,
  CyberplanPolicyTextAreaRow = 5,
  CyberplanPolicyTextAreaColumn = 120,

  CyberplanSecurityPlanAddControlTextAreaRow = 8,
  CyberplanSecurityPlanAddControlTextAreaColumn = 120,

  CyberplanSecurityPlanEditControlPlanTextAreaRow = 10,
  CyberplanSecurityPlanEditControlPlanTextAreaColumn = 80,

  CyberplanCommentsTextAreaRow = 10,
  CyberplanCommentsTextAreaColumn = 30,
  CyberplanCommentsTextMaxLength = 1024,

  CyberplanSecurityDomainReferenceLength = 2,
  CyberplanSecurityDomainReferenceTextAreaRow = 4,
  CyberplanSecurityDomainReferenceTextAreaColumn = 120,
  CyberplanSecurityDomainDescriptionLength = 80,

  CyberplanSecurityControlNistDescriptionLength = 640,
  CyberplanSecurityControlNistAssessmentMethodLength = 1048,
  CyberplanSecurityControlNistAssessmentInterViewLength = 640,
  CyberplanSecurityControlNistAssessmentEvidenceLength = 640,

  CyberplanSecurityRequirementDescriptionLength = 255,
  CyberplanSecurityPolicyTemplateDescriptionLength = 255,


  // Project
  ProjectTextRows = 5,
  ProjectTextColumns = 40,

  // ProjectEstimate
  ProjectName = 255,
  ProjectNumber = 55,
  ProjectCustomerPONumber = 55,

  ProjectDescription = 255,
  ProjectEstimateDescription = 1024,

  ProjectDescriptionRow = 5,
  ProjectDescriptionCol = 40,

  // project milestone
  ProjectMilestoneLength = 40,

  MaxFileSize = 15728640,               // max file size supported by backend; if changed, make sure to change the
                                        // backend as well as nginx configuration

  // Billing Plan
  ServiceOrderNameLength = 40,
  InvoiceRemarkMaxLength = 512,

  // wage determination
  WageDeterminationNumberLength = 20,
  ExecutiveOrderNumberLength = 20,
}
